// extracted by mini-css-extract-plugin
export default {"root":"button-group_root__OQsWd","button":"button-group_button__QK7D0"};